<template>
  <div v-bind:style="{ height: height + 'px' }">
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title style="mar">
          <v-row class="pr-3" align-content="center">
            <v-col>
              <img
                src="https://appmedia.jp/wp-content/uploads/2018/03/d18722b873be6e57380678426669bd30.png"
                width="30px"
              >ピックアップゲーム管理(トップのカルーセル)
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>

        <span style="font-weight:bold;color:#e91e63;">カテゴリ選択：</span>
        <select
          v-model="category"
          @change="dataSearch()"
          style="
            border: 2px solid #2196f3;
            width: 180px;
            padding: 6px;
            margin-right: 10px;
            border-radius: 6px;
          "
        >
          <option v-for="(value, key) in categoryItems" :key="key">{{ value }}</option>
        </select>

        <v-progress-circular v-if="loading" indeterminate></v-progress-circular>

        <a @click="editItem()" class="mr-10 ml-10">新規作成</a>
      </v-toolbar>
    </div>

    <v-card class="ma-4 pa-2">
      <div style="color:red;">※設定する画像サイズは全て「640*300」でお願いします！</div>
      <div style="color:red;">※「表示順」の昇順に表示されます。数字は飛んでも大丈夫です。</div>
    </v-card>
    <v-card class="ma-4">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
      >
        <template v-slot:item.edit="{ item }">
          <v-icon small color="primary" @click="editItem(item)">fas fa-edit</v-icon>
        </template>

        <template v-slot:item.content="{ item }">
          <div @click="editItem(item)" text>
            <div @click="editItem(item)" text>
              <img :src="'https://appmedia.jp'+ item.image" width="250px" v-if="item.image">
            </div>
          </div>
        </template>

        <template v-slot:item.delete="{ item }">
          <v-icon small color="primary" @click="deleteItem(item)">fas fa-trash</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog v-model="showDialog" scrollable persistent max-width="1500px">
        <v-card width="800" :disabled="loading">
          <v-overlay :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" style="width:100%">
              <v-col col="auto" v-if="target_id">データ修正</v-col>
              <v-col col="auto" v-else>新規作成</v-col>
              <v-col col="4" class="text-right">
                <v-btn color="blue darken-1" text @click="closeDialog()" style="font-size:40px;">×</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>
          <v-card-text style="width:100%; background:#efefef;padding:10px;">
            <div style="background-color:#fff">
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col>
                  <v-text-field
                    label="表示順(半角数字)"
                    hide-details="auto"
                    class="pa-0"
                    :rules="[required]"
                    v-model="target_num"
                    maxlength="2"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="カテゴリスラッグ(AppMediaトップのみ「game_top」にすること)"
                    hide-details="auto"
                    class="pa-0"
                    :rules="[required]"
                    v-model="target_category"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col>
                  <v-text-field
                    label="サムネイル画像(/wp-content〜.jpg)"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_img"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col>
                  <v-text-field
                    label="見出し(最大250文字まで)"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_title"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col>
                  <v-text-field label="URL" hide-details="auto" class="pa-0" v-model="target_url"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col>
                  <v-select
                    label="リンクターゲット"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_link_t"
                    :items="select_items"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    label="表示/非表示"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_disp_f"
                    :items="disp_flg"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="pa-4 ml-1" style="width:100%">
                <v-col>
                  <v-text-field
                    label="iOSダウンロードリンク"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_ios_url"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Androidダウンロードリンク"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_android_url"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="closeDialog()">閉じる</v-btn>
            <v-row class="pa-4 ml-1" align="center" style>
              <v-col style="max-width:120px;text-align:right;">
                <v-btn color="blue" dark @click="saveItem()">更新</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/sortablejs@1.8.4/Sortable.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.23.2/vuedraggable.umd.min.js"></script>



<script>
// Ajax通信ライブラリ
import axios from "axios";

import draggable from "vuedraggable";

export default {
  data() {
    return {
      //検索用パラメータ
      site_url: "",
      search: "",
      category: "",
      article_num: "",
      selectedKey: "",
      selectedItem: "",

      loading: false,

      height: 0,
      dialog: false,
      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "5%"
        },
        {
          text: "削除",
          align: "center",
          value: "delete",
          sortable: false,
          width: "5%"
        },
        {
          text: "表示順",
          value: "id",
          width: "10%",
          align: "center"
        },
        {
          text: "サムネ",
          value: "content",
          width: "15%",
          align: "center"
        },
        {
          text: "見出し",
          value: "title",
          width: "40%",
          align: "left"
        },
        {
          text: "カテゴリ",
          value: "category",
          width: "20%",
          align: "center"
        },
        {
          text: "表示",
          value: "disp_flg",
          width: "10%",
          align: "center"
        }
      ],

      list: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        category: "",
        title: "",
        source: "",
        memo: "",
        img_count: 0,
        imageData1: "",
        imageData2: ""
      },

      showDialog: false,

      //画像拡大用
      imgDialog: false,

      // 入力必須の制約
      required: value => !!value || "ひっすだよ",

      // 入力項目
      select_items: ["同一タブ", "別タブ"],
      disp_flg: ["表示", "非表示"],

      categoryItems: { game_top: "game_top", animation: "animation" },

      target_id: "",

      target_num: "",

      target_img: "",

      target_title: "",

      target_url: "",

      target_link_t: "",

      target_category: "",

      target_ios_url: "",

      target_disp_f: "",

      target_android_url: ""
    };
  },

  computed: {},

  methods: {
    //===========================
    // データ取得
    //===========================
    dataSearch: function() {
      // console.log(this.category);
      this.loading = true;
      axios
        .get(process.env.VUE_APP_TOP_BANNER_LIST + "?category=" + this.category)
        .then(response => {
          // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);
          // console.log(values);

          values.forEach(value => {
            const item = this.itemPush(value);
            items.push(item);
          });
          this.list = items;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //===========================
    // 受け取った投稿データを配列に追加
    //===========================
    itemPush: function(value) {
      var item = {
        seq_id: value.seq_id,
        id: value.id,
        image: value.image,
        title: value.title,
        url: value.url,
        target: value.target,
        ioslink: value.ioslink,
        androidlink: value.androidlink,
        category: value.category,
        disp_flg: value.disp_flg
        // showDialog: false,
      };
      return item;
    },

    //===========================
    // 編集画面開いたとき
    //===========================
    editItem(item) {
      if ((item === void 0) === false) {
        this.target_id = item.seq_id;
        this.target_num = item.id;
        this.target_img = item.image;
        this.target_title = item.title;
        this.target_url = item.url;
        this.target_category = item.category;
        this.target_ios_url = item.ioslink;
        this.target_android_url = item.androidlink;
        this.target_link_t = item.target;
        this.target_disp_f = item.disp_flg;

        this.new_create_flg = false;
      } else {
        this.target_id = "";
        this.target_num = "";
        this.target_img = "";
        this.target_title = "";
        this.target_url = "";
        this.target_category = "";
        this.target_ios_url = "";
        this.target_android_url = "";
        this.target_link_t = "同一タブ";
        this.target_disp_f = "表示";
        this.new_create_flg = true;
      }

      this.showDialog = true;
    },

    //===========================
    // 更新
    //===========================
    saveItem() {
      if (this.target_num == "" || this.target_num == null) {
        alert("表示順を入力してください");
        return;
      }

      if (this.target_category == "" || this.target_category == null) {
        alert("カテゴリを入力してください");
        return;
      }

      var msg = "";
      if (this.target_id.length == 0) {
        msg = "新規登録";
      } else {
        msg = "更新";
      }
      if (!window.confirm("データを" + msg + "します。よろしいですか？")) {
        return;
      }

      var item = {
        seq_id: this.target_id,
        id: this.target_num,
        image: this.target_img,
        title: this.target_title,
        url: this.target_url,
        category: this.target_category,
        ios_url: this.target_ios_url,
        android_url: this.target_android_url,
        target: this.target_link_t,
        disp_flg: this.target_disp_f
      };

      axios
        .post(process.env.VUE_APP_TOP_BANNER_UPDATE, {
          data: item
        })

        .then(() => {
          console.log(item);
          alert("更新しました！");
          this.showDialog = false;
          this.dataSearch();
        })
        .catch(error => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //===========================
    // 閉じる
    //===========================
    closeDialog() {
      var check1 = this.before_datas;
      var check2 = JSON.stringify(this.items);
      if (check1 != "[]" && check1 != check2) {
        if (
          !window.confirm(
            "変更が保存されていません。移動すると変更内容が失われます。"
          )
        ) {
          return true;
        }
      }

      this.showDialog = false;
    },

    //===========================
    // 削除
    //===========================
    deleteItem(item) {
      var result = confirm("選択したデータを削除しますか？");
      if (result == false) {
        return;
      }

      item.id = 9;
      item.image = "";
      item.title = "";
      item.url = "";
      item.ios_url = "";
      item.android_url = "";
      item.target = "同一タブ";
      item.disp_flg = "表示";

      console.log(item);

      var self = this;
      axios
        .post(process.env.VUE_APP_TOP_BANNER_UPDATE, {
          data: item
        })
        .then(function(response) {
          console.log(response);
          self.close();
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    }
  }
};
</script>

<style>
.v-data-table th span {
  font-size: 12px !important;
}

.v-data-table table th {
  font-weight: normal;
  color: #888;
}

.v-data-table td,
.v-data-table th {
  padding: 2px;
  height: 30px !important;
}
.v-data-table tr:last-child td,
.v-data-table tr:last-child th {
  border: none;
}
table tr:nth-child(odd) td {
  background: #fbf9ff;
}
.main_table td,
.main_table th {
  background: transparent !important;
}

.main_table tr:last-child th,
.main_table tr:last-child td {
  border: none !important;
}
</style>